module.exports = __webpack_public_path__ + "roboto-mediumitalic-webfont.e43d48d6e57a31a781fc.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-mediumitalic-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-mediumitalic-webfont.woff2
// module chunks = styles